var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"app-container"}},[_c('HeaderView'),_c('div',{staticClass:"px-2 py-2"},[_c('router-view'),_c('ApiError')],1),_c('FooterView'),(!_vm.$store.getters.hasSubscription)?_c('SubscriptionOverlay'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }